/**
 * Redireciona atravessando o limite React via mudança de hash, para destinos que o
 * roteador chrome-less da folha não conhece (ex: '/pages/login', 'pages/error/dss' —
 * servidos pelo AngularHost/React, fora de LEAF_ROUTES). Um guard de negação deve
 * chamar esta função em vez de `Navegacao.run(...)`/`Router.navigate(...)`: o Router
 * interno da folha não tem essas rotas registradas e o redirect ficaria inerte.
 *
 * Espelha o mesmo padrão de travessia já usado por `redirectToAuthRoute` no
 * axios-instance.ts do React, para manter uma única convenção de redirect por hash
 * em toda a aplicação.
 */
export function redirectAcrossReactBoundary(path: string): void {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  window.location.hash = `#${normalizedPath}`;
}
